const HypePlaylist = [
  {
    url: "https://x2convert.com/Thankyou?token=U2FsdGVkX199a5ngfAEYoaYbcBvsuZ4Sr8dkOG5exAVEUrJAAN7Q9CZBNEGrEUmu22DNu20lss82yHtX6mnS3rfhZ81gEmDaAEqKxCwaVLyIz5TaAXv9LoJa5VEkjcxIN9cpl%2bkoEDlqqcM0TwYEgD7I8U6r0q6IGvK35JLyEe3ziqlG4%2b%2fX2aI1GtBY0LkRi0vYdPoFlfldOLGNkH4bhg%3d%3d&s=youtube&id=&h=9005676567094149531",
    cover:
    'https://64.media.tumblr.com/fe4c545adf65339c3bb1cb0bf655ef7a/65119ddf74dbe4c3-c4/s400x600/72f4cc79d1e5ff69edd98311533130b049159bb0.gifv',
    artist: {
      name: "Upbeat Lo-fi Hip Hop Mix",
      song: "Jubilant Day",
    },
  },
];

export default HypePlaylist;
